module.exports = __webpack_public_path__ + "static/media/Service Information.dda43618.jpg";